import * as React from "react"

export interface ComparisonListProps {}

export const ComparisonList: React.FC<ComparisonListProps> = ({ children }) => {
  return (
    <div className="w-4/5 m-auto grid gap-3 lg:w-full">
      {children}
    </div>
  )
}
